export function exportTableToCSVInternal({ fetchAllData, isFetchingDataGetter, getCurrentData, getAuthorUrl }) {
  // Fetch all data first
  fetchAllData() // this will populate currentData with all rows
  // Wait for data to be ready
  const checkDataReady = setInterval(() => {
    if (!isFetchingDataGetter()) {
      // once fetch is complete
      clearInterval(checkDataReady)
      const currentData = getCurrentData()
      if (!currentData || !currentData.length) {
        return
      }
      const headers = [
        'Page Title',
        'Last Modified Date',
        'Last Activation Date',
        'Status',
        'Is Redirect',
        'Redirect Target',
        'Redirected Locales',
        ...window.locales.map(l => `Status (${l})`),
        'Outdated Locales',
        'Published Locales',
        'UnPublished Locales',
        'NonExist Locales',
      ]
      let csvContent = headers.map(h => `"${h}"`).join(',') + '\n'
      currentData.forEach(item => {
        // Collect all redirect information
        const redirectedItems = []
        let hasAnyRedirect = false
        const redirectTargets = []

        // Check master redirect
        if (item.masterIsRedirect === 'true') {
          hasAnyRedirect = true
          redirectedItems.push('Master')
          if (item.masterRedirectTarget && item.masterRedirectTarget !== 'none') {
            redirectTargets.push(`Master: ${item.masterRedirectTarget}`)
          }
        }

        // Check locale redirects
        window.locales.forEach(locale => {
          const { isRedirect, redirectTarget } = item.translationStatus[locale] || {}
          if (isRedirect === 'true') {
            hasAnyRedirect = true
            redirectedItems.push(locale)
            if (redirectTarget && redirectTarget !== 'none') {
              redirectTargets.push(`${locale}: ${redirectTarget}`)
            }
          }
        })

        const rowData = [
          `=HYPERLINK("${getAuthorUrl(item.path)}","${item.title.replace(/"/g, '""')}")`, // Page Title as clickable hyperlink
          item.lastModified || '',
          item.lastActivated || '',
          item.status || '',
          hasAnyRedirect ? 'Yes' : 'No',
          redirectTargets.length > 0 ? redirectTargets.join('; ') : '',
          redirectedItems.length > 0 ? redirectedItems.join(', ') : 'None',
          ...window.locales.map(locale => {
            const { status } = item.translationStatus[locale] || {}
            if (status === 'up-to-date') {
              return '✓'
            }
            if (status === 'outdated') {
              return '⛔'
            }
            return '✗'
          }),
          item.outdatedLocales?.join(', ') || 'NA',
          item.publishedLocales?.join(', ') || 'NA',
          item.unpublishedLocales?.join(', ') || 'NA',
          item.nonexistLocales?.join(', ') || 'NA',
        ]
        const cleanRow = rowData
          .map(col => {
            return `"${(col || '').toString().replace(/"/g, '""')}"`
          })
          .join(',')
        csvContent += cleanRow + '\n'
      })
      const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'Translation_data.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }, 100) // check every 100ms until data is ready
}
